import React, { lazy } from 'react';
const bonuses = [{
  image: 'https://cdn.magicpatterns.com/uploads/ogCnmHsR3PYj1X49qy547s/Bonus_1.png',
  alt: 'Bonus 1: 7-Day Starter Meal Plan guide cover'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/8LVxiTcc7VffUBNXW2mPrj/Bonus_2.png',
  alt: 'Bonus 2: Smart Grocery List for Women 50+ guide cover'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/q6UrRW3o4JnZYz2ALvsU5Q/Bonus_3.png',
  alt: 'Bonus 3: Weekend Prep Guide cover'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5En5JQBhhf2pP9vfcdk8Lc/Bonus_4.png',
  alt: 'Bonus 4: Hormone-Friendly Pantry Checklist cover'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/sGrS5krsykDWJEpeTxDi6Q/Bonus_5.png',
  alt: 'Bonus 5: 10 Smoothies to Beat the Morning Energy Crash cover'
}];
export function BonusesSection() {
  return <section className="bg-white py-20 sm:py-24" data-id="element-23" data-mp="1jiqkmf27y1vq">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-24" data-mp="1jkbioenqs2yc">
        <div className="mx-auto max-w-2xl text-center" data-id="element-25" data-mp="3pqtycxt5ull6">
          <p className="eyebrow" data-id="element-26" data-mp="3psesimbkc2ii">Free bonuses included</p>
          <h2 className="section-title mt-3" data-id="element-27" data-mp="3tsyklbha4fxs">
            You also get these 5 free bonuses when you order today
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-28" data-mp="2np0u1jvoxwm">
          {bonuses.map(({
          image,
          alt
        }, index) => <figure key={alt} className={`overflow-hidden rounded-2xl border border-forest/10 bg-cream p-3 shadow-sm ${index === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-0.625rem)] lg:col-span-1 lg:w-auto' : ''}`} data-id="element-29" data-mp="ckbkwo4drkxl" data-mpi={index}>
              <img src={image} alt={alt} className="aspect-square w-full rounded-xl object-contain" data-id="element-30" data-mp="qb6xaae38k5x" />
            </figure>)}
        </div>

        <div className="mx-auto mt-10 max-w-xl rounded-2xl bg-forest px-6 py-6 text-center shadow-lg shadow-forest/10" data-id="element-31" data-mp="1094kqvo4icxh">
          <p className="text-sm font-bold text-sage" data-id="element-32" data-mp="amaay3izqedg">
            5 bonuses included free with your guide
          </p>
          <a href="https://pay.hotmart.com/Q106802782G?checkoutMode=10" className="mt-4 inline-flex w-full items-center justify-center rounded-full bg-terracotta px-8 py-5 text-base font-extrabold tracking-wide text-white shadow-lg shadow-black/20 transition hover:bg-[#a84a35] focus:outline-none focus:ring-4 focus:ring-cream/40 sm:w-auto" data-id="element-33" data-mp="5np95zo3bmmw">
            GET INSTANT ACCESS — $19.97
          </a>
          <p className="mt-4 text-sm font-semibold text-cream/80" data-id="element-34" data-mp="oezwk6ulxha1">
            Secure checkout · 7-day guarantee · Instant access
          </p>
        </div>
      </div>
    </section>;
}